var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExperiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/Beaker/Line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6666 4.66659V7.15302C10.6666 7.27106 10.6979 7.38698 10.7574 7.48893L13.5788 12.3255C14.3565 13.6588 13.3948 15.3333 11.8512 15.3333L4.14867 15.3333C2.60509 15.3333 1.64335 13.6588 2.42111 12.3255L5.24245 7.48893C5.30193 7.38698 5.33327 7.27106 5.33327 7.15302V4.66659C4.9651 4.66655 4.66666 4.36809 4.66666 3.99992C4.66666 3.63175 4.9651 3.33328 5.33327 3.33325C5.33325 3.33325 5.33328 3.33325 5.33327 3.33325L10.6666 3.33325C11.0348 3.33325 11.3333 3.63173 11.3333 3.99992C11.3333 4.36811 11.0348 4.66659 10.6666 4.66659ZM9.60571 8.16076L12.427 12.9973C12.6863 13.4418 12.3657 13.9999 11.8512 13.9999L4.14867 13.9999C3.63415 13.9999 3.31356 13.4418 3.57282 12.9973L6.39416 8.16076C6.57258 7.85489 6.6666 7.50713 6.6666 7.15302L6.6666 4.66659L9.33327 4.66659V7.15302C9.33327 7.50713 9.42728 7.85489 9.60571 8.16076Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M3.33334 11.3334C3.33334 10.9652 3.63182 10.6667 4.00001 10.6667L12 10.6667C12.3682 10.6667 12.6667 10.9652 12.6667 11.3334C12.6667 11.7016 12.3682 12.0001 12 12.0001L4.00001 12.0001C3.63182 12.0001 3.33334 11.7016 3.33334 11.3334Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 2.00008C9.70152 2.00008 10 1.7016 10 1.33341C10 0.965225 9.70152 0.666748 9.33333 0.666748C8.96514 0.666748 8.66667 0.965225 8.66667 1.33341C8.66667 1.7016 8.96514 2.00008 9.33333 2.00008Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 2.66675C7.03486 2.66675 7.33333 2.36827 7.33333 2.00008C7.33333 1.63189 7.03486 1.33341 6.66667 1.33341C6.29848 1.33341 6 1.63189 6 2.00008C6 2.36827 6.29848 2.66675 6.66667 2.66675Z",
    fill: "#777E91"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiment);
export default __webpack_public_path__ + "static/media/experiment.e05bf9f7d0cb440460328970b1bba202.svg";
export { ForwardRef as ReactComponent };